import {
  invalidateKB,
  invalidateKBAfterChatDeletion,
} from '@/services/invalidateKB';
import { trpc } from '@/services/trpc';

export function useChatMutation() {
  const utils = trpc.useUtils();

  const create = trpc.chats.create.useMutation({
    onSuccess: async () =>
      Promise.all([
        utils.chats.findAll.invalidate(),
        utils.chats.findAllAccessible.invalidate(),
      ]),
  });

  const duplicate = trpc.chats.duplicate.useMutation({
    onSuccess: async () =>
      Promise.all([
        utils.chats.findAllAccessible.invalidate(),
        invalidateKB(),
        utils.mcpIntegrations.findAll.invalidate(),
        utils.httpTools.findAll.invalidate(),
        utils.skills.findAll.invalidate(),
        utils.clientSideFormTools.findAll.invalidate(),
        utils.clientSideFormTools.findOne.invalidate(),
      ]),
  });

  const update = trpc.chats.update.useMutation({
    onSuccess: async (data, { id }) => {
      await Promise.all([
        utils.chats.findAll.invalidate(),
        utils.chats.findAllAccessible.invalidate(),
        utils.chats.findOne.invalidate({ id }),
      ]);
    },
  });

  const remove = trpc.chats.delete.useMutation({
    onSuccess: async () =>
      Promise.all([
        utils.chats.findAllAccessible.invalidate(),
        invalidateKBAfterChatDeletion(),
      ]),
  });

  const exportToXls = trpc.chats.exportToXls.useMutation({});

  return {
    duplicate,
    create,
    update,
    remove,
    exportToXls,
  };
}
